import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';

/**
 * The bare `/teams` path has no league context. Redirect to the league-scoped
 * Teams page (the wireframe Teams page) for the currently selected banner league,
 * or to the league list when nothing is selected yet. This replaces the legacy
 * unscoped Teams hub so all team browsing/creation flows through the wireframe pages.
 */
const TeamsIndexRedirect: React.FC = () => {
  const selectedLeagueId = useSelector((state: RootState) => state.ui.selectedLeagueId);
  return (
    <Navigate to={selectedLeagueId ? `/leagues/${selectedLeagueId}/teams` : '/leagues'} replace />
  );
};

export default TeamsIndexRedirect;
